/* eslint-disable consistent-return */
import OrderQuery from 'Query/Order.query';
import {
    OrderDispatcher as SourceOrderDispatcher
} from 'SourceStore/Order/Order.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { getOrderList } from 'Store/Order/Order.action';
import { isSignedIn } from 'Util/Auth';
import { fetchQuery, getErrorMessage } from 'Util/Request';

/** @namespace Pwa/Store/Order/Dispatcher/OrderDispatcher */
export class OrderDispatcher extends SourceOrderDispatcher {
    // TODO implement logic
    requestOrders(dispatch, page = 1) {
        const query = OrderQuery.getPaginatedOrderListQuery({ page });
        if (!isSignedIn()) {
            return;
        }

        return fetchQuery(query).then(
            /** @namespace Pwa/Store/Order/Dispatcher/fetchQuery/then */
            ({ getCustomerOrderList: orders }) => {
                dispatch(getOrderList(orders, false));
            },
            /** @namespace Pwa/Store/Order/Dispatcher/fetchQuery/then */
            (error) => dispatch(showNotification('error', getErrorMessage(error)))
        );
    }

    requestSearchOrders(dispatch, orders) {
        const { searchOrderbySearchterm } = orders;

        const { order_count } = searchOrderbySearchterm;

        console.log('nup117', searchOrderbySearchterm);

        if (!isSignedIn()) {
            return;
        }

        if (!order_count) {
            // eslint-disable-next-line max-len
            return dispatch(showNotification('error', 'No orders match your search. Please try again with a different keyword.'));
        }

        return dispatch(getOrderList(
            searchOrderbySearchterm, false
        ));
    }

    async getOrderById(dispatch, id) {
        try {
            const { getOrderById: result } = await fetchQuery(OrderQuery.getOrderByIdQuery(id));

            return result;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return null;
        }
    }

    async getInvoiceById(dispatch, id) {
        try {
            const { invoiceDetailData: response } = await fetchQuery(OrderQuery.getInvoiceDetailsData(id));

            return response;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return null;
        }
    }

    async getInvoicePdfById(dispatch, options) {
        try {
            const { invoicePdfDownload: response } = await fetchQuery(OrderQuery.getInvoicePdfData(options));

            return response;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return null;
        }
    }
}

export default new OrderDispatcher();
